export {useCollator} from 'react-aria/useCollator';
